import { render, staticRenderFns } from "./VisitPointAssignedList.vue?vue&type=template&id=28b70614&scoped=true&"
import script from "./VisitPointAssignedList.vue?vue&type=script&lang=js&"
export * from "./VisitPointAssignedList.vue?vue&type=script&lang=js&"
import style0 from "./VisitPointAssignedList.vue?vue&type=style&index=0&id=28b70614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b70614",
  null
  
)

export default component.exports